module.exports = __webpack_public_path__ + "img/6c53378.png";